import React from 'react'
import Fade from 'react-reveal/Fade'
import './App.css';

class Register extends React.Component {
    
  constructor(props) {
    super(props);
    this.state = {email: '', name: ''};
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit()  {
    alert('Thanks for choosing our company, ' + this.state.name + '. Information will be send on ' + this.state.email + ' email');
    localStorage.setItem('name',this.state.name);
    localStorage.setItem('email',this.state.email);
    
    fetch('/customers', { 
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: this.state.name,
        email: this.state.email,
      })
    })
    .then(res => res.json())
    .then(data => console.log(data))
    .catch(err => console.log(err));
  }

  handleChange(event) {
    this.setState({email: event.target.value});
  }
  handleChangeName(event) {
    this.setState({name: event.target.value});
  }
  

    render(){ return(
<form onSubmit={this.handleSubmit}><div align="center"><Fade><h1>Do you want to join?</h1></Fade>
    <label><input class="sizeof" type="text" placeholder="E-mail" value={this.state.email} onChange={this.handleChange}/></label>
    <label><input class="sizeof" type="text" placeholder="Name" value={this.state.name} onChange={this.handleChangeName}/></label><br />
    <label><input class="inputJoin" type="submit" value="Register"/></label></div></form>);
    }

}


export default Register;